module.exports = "<div ng-if=\"$ctrl.error\" class=\"u-error\">{{ $ctrl.error }}</div>\r\n\r\n<button class=\"button button--primary\" ng-click=\"$ctrl.saveCard()\" ng-if=\"!$ctrl.cardSaved\">\r\n    Save my card for future purchases\r\n</button>\r\n<button class=\"button button--primary\" ng-if=\"$ctrl.cardSaved\" disabled>\r\n    Card saved successfully <i class=\"iconww-Tick\"></i>\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/order/savedcard/save-card.component.html
// module id = 569
// module chunks = 0